<template>
  <v-dialog transition="slide-x-reverse-transition" v-model="dialogModel" max-width="720">
    <ContentQuestions
      :active="active"
      :lesson-id="lessonId"
      :course-id="courseId"
      :schedule-id="scheduleId"
      show-close
      @close="close"
    />
  </v-dialog>
</template>

<script>
import ContentQuestions from './ContentQuestions.vue';

export default {
  name: 'QuestionsDialog',
  components: {
    ContentQuestions,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true,
    },
    lessonId: {
      type: [Number, String],
      required: true,
    },
    courseId: {
      type: [Number, String],
      required: true,
    },
    scheduleId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    dialogModel: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit('dialog:change', value);
      },
    },
  },
  methods: {
    close() {
      this.$emit('dialog:change', false);
    },
  },
};
</script>
